import { combineReducers } from "redux";

import { testCaseReducer } from "./testCaseReducer";

export default combineReducers({
  testCaseState: testCaseReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js